import React from "react";

export default function InterdicaoLocomotivasFields({
  Section,
  DropdownField,
  DateDropdownField,
  form,
  onChange,
  sbOptions,
  motivoOptions,
  motivoOptionsLocomotivas,
  tipoOperacaoOptions,
  postoOrigemSosOptions,
  nivelAcionamentoOptions,
  kmHint,
  kmError,
}) {
  const locomotivasMotivoOptions =
    Array.isArray(motivoOptionsLocomotivas) && motivoOptionsLocomotivas.length
      ?motivoOptionsLocomotivas
      : Array.isArray(motivoOptions)
        ?motivoOptions
        : [];

  return (
    <>
      <Section title="Operação">
        <div className="interdNova-grid interdNova-grid--3">
          <DateDropdownField
            label="Data"
            value={form.locomotivasData}
            onChange={onChange("locomotivasData")}
          />

          <label className="interdNova-field">
            <span>Horário início</span>
            <input
              type="time"
              value={form.locomotivasHorarioInicio}
              onChange={onChange("locomotivasHorarioInicio")}
            />
          </label>

          <label className="interdNova-field">
            <span>Trem</span>
            <input
              type="text"
              value={form.locomotivasTrem}
              onChange={onChange("locomotivasTrem")}
              placeholder="Ex.: M123"
            />
          </label>

          <DropdownField
            label="Seção de Bloqueio"
            value={form.locomotivasSbParada}
            onChange={onChange("locomotivasSbParada")}
            options={sbOptions}
            searchable
            searchInline
            preferredDirection="down"
            searchPlaceholder="Digite a seção de bloqueio"
            placeholder="Selecione a seção"
          />

          <label className="interdNova-field">
            <span>Km</span>
            <input
              type="text"
              className={kmError ?"interdNova-inputInvalid" : ""}
              value={form.locomotivasKm}
              onChange={onChange("locomotivasKm")}
              placeholder="125,300"
              aria-invalid={Boolean(kmError)}
            />
            {kmError ?(
              <small className="interdNova-fieldError">{kmError}</small>
            ) : kmHint ?(
              <small className="interdNova-fieldHint">{kmHint}</small>
            ) : null}
          </label>

          <label className="interdNova-field">
            <span>Nº Ativo</span>
            <input
              type="text"
              value={form.locomotivasNumeroAtivo}
              onChange={onChange("locomotivasNumeroAtivo")}
              placeholder="Ex.: 9043"
            />
          </label>

          <label className="interdNova-field">
            <span>Frota</span>
            <input
              type="text"
              value={form.locomotivasFrota}
              onChange={onChange("locomotivasFrota")}
              placeholder="Ex.: AC44"
            />
          </label>

          <DropdownField
            label="Tipo de operação"
            value={form.locomotivasTipoOperacao}
            onChange={onChange("locomotivasTipoOperacao")}
            options={tipoOperacaoOptions}
            placeholder="Selecione o tipo"
            preferredDirection="down"
          />

          <DropdownField
            label="Posto de origem do SOS"
            value={form.locomotivasPostoOrigemSos}
            onChange={onChange("locomotivasPostoOrigemSos")}
            options={postoOrigemSosOptions}
            placeholder="Selecione o posto"
            preferredDirection="down"
          />

          <label className="interdNova-field">
            <span>Mecânico acionado</span>
            <input
              type="text"
              value={form.locomotivasMecanicoAcionado}
              onChange={onChange("locomotivasMecanicoAcionado")}
              placeholder="Nome do mecânico"
            />
          </label>

          <DropdownField
            label="Nível de Acionamento"
            value={form.locomotivasNivelAcionamento}
            onChange={onChange("locomotivasNivelAcionamento")}
            options={nivelAcionamentoOptions}
            placeholder="Selecione o nível"
            preferredDirection="down"
          />

          <DropdownField
            label="Motivo"
            value={form.locomotivasMotivo}
            onChange={onChange("locomotivasMotivo")}
            options={locomotivasMotivoOptions}
            placeholder="Selecione o motivo"
            searchable
            searchInline
            preferredDirection="down"
            searchPlaceholder="Digite o motivo"
            menuMaxHeight={164}
          />

          <label className="interdNova-field interdNova-field--full">
            <span>Obs.</span>
            <textarea
              rows="3"
              className="interdNova-observacao"
              value={form.locomotivasObservacao}
              onChange={onChange("locomotivasObservacao")}
              placeholder="Observações da interdição"
            />
          </label>
        </div>
      </Section>

      <Section title="Liberação">
        <div className="interdNova-grid interdNova-grid--3">
          <DropdownField
            label="Tem previsão?"
            value={form.locomotivasTemLiberacao}
            onChange={onChange("locomotivasTemLiberacao")}
            preferredDirection="up"
            options={[
              { value: "nao", label: "Não" },
              { value: "sim", label: "Sim" },
            ]}
          />

          {form.locomotivasTemLiberacao === "sim" ?(
            <>
              <DateDropdownField
                label="Data liberação"
                value={form.locomotivasDataLiberacao}
                onChange={onChange("locomotivasDataLiberacao")}
              />

              <label className="interdNova-field">
                <span>Horário liberação</span>
                <input
                  type="time"
                  value={form.locomotivasHorarioLiberacao}
                  onChange={onChange("locomotivasHorarioLiberacao")}
                />
              </label>
            </>
          ) : null}
        </div>
      </Section>
    </>
  );
}
